import React, { Component } from "react"
import SimpleReactLightbox from "simple-react-lightbox"; // Import Simple React Lightbox
import WebGallery from "./web-dev-gallery"
import SeoGallery from "./seo-gallery"
import { Link } from "gatsby"
import SocialGallery from "./social-gallery";
import AllGallery from "./all-gallery"

class GalleryX extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: true,
            value: '',
            active: ''
        };
        this.handleClick = this.handleClick.bind(this);

    }
    componentDidUpdate() {
        const x = document.querySelector('.gallery');
        x.classList.add('active-gallery');
    }
    componentDidMount() {
        document.querySelector(`#${this.props.name}`).classList.add('active');
        this.setState({
            active: document.querySelector(`#${this.props.name}`),
            value: this.props.name
        });
    }

    handleClick(e) {
        e.preventDefault();
        this.setState({ value: e.target.id })
        e.target.parentElement.classList.add('active');
        this.state.active.classList.remove('active');

        this.setState({ active: document.querySelector(`.active`) });
        console.log(e.target.parentElement);
        if (e.target.id != "all") {
            document.querySelector('#all').style = "margin-left:10px";
        }
        else {
            document.querySelector('#all').style = "";
        }

    }
    render() {
        return (
            <div className="projects">
                <h2>Değer kattığımız <br />markalara yakından bakın.</h2>
                <div className="gallery-nav">
                    <ul >
                        <li><Link to="#" onClick={this.handleClick} id="all" >HEPSİ</Link></li>
                        <li><Link to="#" onClick={this.handleClick} id="web" >UI/UX - Website Geliştirme </Link></li>
                        <li><Link to="#" onClick={this.handleClick} id="social" >Sosyal Medya</Link></li>
                        <li><Link to="#" onClick={this.handleClick} id="seo" >SEO/SEM</Link></li>
                    </ul>
                </div>
                <SimpleReactLightbox className="x">
                    {
                        this.state.value === "web" ? <WebGallery /> : null
                    }
                    {
                        this.state.value === "all" ? <AllGallery /> : null
                    }
                    {
                        this.state.value === "social" ? <SocialGallery /> : null
                    }
                    {
                        this.state.value === "seo" ? <SeoGallery /> : null
                    }
                </SimpleReactLightbox>
            </div>
        );
    }
}

export default GalleryX;